/* Centro de ayuda (sections/tt-help-center.liquid + snippets/tt-help-postventa.liquid)
   · Navegación por #tema (enlace directo y botón atrás), grupos plegables, desplegable en celular.
   · Buscador en títulos y texto de todos los temas.
   · Formulario postventa: valida, arma el mensaje, vista previa en modal y envío por WhatsApp. */
(function () {
  'use strict';

  function norm(t) {
    return String(t || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  }

  function initHelp(root) {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';
    // Si se vuelve a armar (contenido nuevo desde la API), se sueltan los listeners anteriores
    if (root._ttAbort) root._ttAbort.abort();
    var ac = window.AbortController ? new AbortController() : null;
    root._ttAbort = ac;
    var sig = ac ? { signal: ac.signal } : false;

    var articles = [].slice.call(root.querySelectorAll('[data-tt-help-article]'));
    var links = [].slice.call(root.querySelectorAll('[data-tt-help-link]'));
    var results = root.querySelector('[data-tt-help-results]');
    var resultsList = root.querySelector('[data-tt-help-results-list]');
    var resultsTitle = root.querySelector('[data-tt-help-results-title]');
    var q = root.querySelector('[data-tt-help-q]');
    var nav = root.querySelector('.tt-help__nav');
    var navToggle = root.querySelector('[data-tt-help-navtoggle]');
    var mobile = window.matchMedia('(max-width: 899px)');
    if (!articles.length) return;

    // ── Mostrar un tema ──
    function show(handle, opts) {
      opts = opts || {};
      var art = articles.filter(function (a) { return a.getAttribute('data-tt-help-article') === handle; })[0] || articles[0];
      var h = art.getAttribute('data-tt-help-article');
      articles.forEach(function (a) { a.classList.toggle('is-active', a === art); });
      if (results) results.hidden = true;
      links.forEach(function (l) {
        // si el tema está en dos grupos, se marca el del grupo del tema (o el primero)
        l.classList.remove('is-active');
      });
      var candidates = links.filter(function (l) { return l.getAttribute('data-tt-help-link') === h; });
      var mark = candidates.filter(function (l) { return l.getAttribute('data-group') === (opts.group || art.getAttribute('data-group')); })[0] || candidates[0];
      if (mark) {
        mark.classList.add('is-active');
        var grp = mark.closest('[data-tt-help-group]');
        if (grp) setGroup(grp, true);
      }
      if (opts.push && location.hash !== '#' + h) history.pushState(null, '', '#' + h);
      if (opts.scroll) {
        if (mobile.matches) closeNav();
        var box = root.querySelector('.tt-help__content');
        var top = box.getBoundingClientRect().top + window.scrollY - 120;
        if (window.scrollY > top || mobile.matches) window.scrollTo({ top: top, behavior: 'smooth' });
      }
    }

    // ── Grupos plegables ──
    function setGroup(grp, open) {
      grp.classList.toggle('is-open', open);
      var b = grp.querySelector('[data-tt-help-groupbtn]');
      if (b) b.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    root.querySelectorAll('[data-tt-help-groupbtn]').forEach(function (b) {
      b.addEventListener('click', function () {
        var grp = b.closest('[data-tt-help-group]');
        setGroup(grp, !grp.classList.contains('is-open'));
      });
    });

    // ── Desplegable "Centro de ayuda" en celular ──
    function closeNav() { nav.classList.remove('is-open'); navToggle.setAttribute('aria-expanded', 'false'); }
    if (navToggle) navToggle.addEventListener('click', function () {
      var open = !nav.classList.contains('is-open');
      nav.classList.toggle('is-open', open);
      navToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }, sig);
    // En celular los grupos parten cerrados (salvo el del tema activo)
    if (mobile.matches) {
      root.querySelectorAll('[data-tt-help-group]').forEach(function (g) {
        setGroup(g, !!g.querySelector('.tt-help__item.is-active'));
      });
    }

    links.forEach(function (l) {
      l.addEventListener('click', function (e) {
        e.preventDefault();
        show(l.getAttribute('data-tt-help-link'), { push: true, scroll: true, group: l.getAttribute('data-group') });
      });
    });
    // Enlaces dentro de los textos a otros temas (#tema)
    root.addEventListener('click', function (e) {
      var a = e.target.closest('.tt-help__body a[href^="#"], .tt-help__results a[href^="#"], [data-tt-help-goto]');
      if (!a) return;
      var h = a.getAttribute('href').slice(1);
      if (!articles.some(function (x) { return x.getAttribute('data-tt-help-article') === h; })) return;
      e.preventDefault();
      show(h, { push: true, scroll: true });
    }, sig);

    function fromUrl() {
      var h = decodeURIComponent((location.hash || '').slice(1));
      if (!h) { var m = location.search.match(/[?&]tema=([^&]+)/); if (m) h = decodeURIComponent(m[1]); }
      if (!h && /[?&]ticket=/.test(location.search) && !root.querySelector('#mi-ticket')) {
        // link viejo del correo apuntando al centro de ayuda → landing "Mi solicitud"
        var page = root.getAttribute('data-sac-page');
        if (page && page !== location.pathname) {
          var qs = new URLSearchParams(location.search), out = new URLSearchParams();
          ['ticket', 'token'].forEach(function (k) { if (qs.get(k)) out.set(k, qs.get(k)); });   // solo esos (sin ?view= ni otros)
          location.replace(page + '?' + out.toString()); return;
        }
      }
      if (h) show(h, {});
    }
    window.addEventListener('popstate', fromUrl, sig);
    window.addEventListener('hashchange', fromUrl, sig);
    fromUrl();

    // ── Buscador ──
    var index = articles.filter(function (a) { return !a.hasAttribute('data-tt-help-nosearch'); }).map(function (a) {
      return { h: a.getAttribute('data-tt-help-article'), title: a.getAttribute('data-title'), group: a.getAttribute('data-group'),
               text: bodyText(a.querySelector('.tt-help__body') || a) };
    });
    // Texto del tema para buscar: párrafos separados y SIN el formulario postventa
    function bodyText(el) {
      var c = el.cloneNode(true);
      c.querySelectorAll('form, select, .tt-pv-modal').forEach(function (n) { n.remove(); });
      c.querySelectorAll('p, li, br').forEach(function (n) { n.insertAdjacentText('afterend', ' '); });
      return c.textContent.replace(/\s+/g, ' ').trim();
    }
    function snippet(text, term) {
      var i = norm(text).indexOf(term);
      if (i < 0) return text.slice(0, 140) + (text.length > 140 ? '…' : '');
      var start = Math.max(0, i - 50);
      return (start > 0 ? '…' : '') + text.slice(start, i + 90) + '…';
    }
    function search(raw) {
      var term = norm(raw).trim();
      if (!term) { fromUrl(); if (!location.hash) show(articles[0].getAttribute('data-tt-help-article'), {}); return; }
      var words = term.split(/\s+/);
      var hits = index.map(function (it) {
        var t = norm(it.title), b = norm(it.text), score = 0;
        words.forEach(function (w) { if (t.indexOf(w) > -1) score += 3; if (b.indexOf(w) > -1) score += 1; });
        return { it: it, score: score };
      }).filter(function (x) { return x.score > 0; }).sort(function (a, b) { return b.score - a.score; });
      articles.forEach(function (a) { a.classList.remove('is-active'); });
      results.hidden = false;
      resultsTitle.textContent = hits.length ? hits.length + (hits.length === 1 ? ' resultado' : ' resultados') + ' para “' + raw.trim() + '”' : 'Sin resultados para “' + raw.trim() + '”';
      resultsList.innerHTML = '';
      if (!hits.length) {
        var li = document.createElement('li');
        li.className = 'tt-help__noresult';
        li.textContent = 'Prueba con otra palabra (por ejemplo: garantía, despacho, retiro, pago) o elige un tema en el menú.';
        resultsList.appendChild(li);
      }
      hits.slice(0, 12).forEach(function (x) {
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + x.it.h;
        a.innerHTML = '<span class="tt-help__rgroup"></span><strong></strong><span class="tt-help__rtext"></span>';
        a.querySelector('.tt-help__rgroup').textContent = x.it.group;
        a.querySelector('strong').textContent = x.it.title;
        a.querySelector('.tt-help__rtext').textContent = snippet(x.it.text, words[0]);
        li.appendChild(a); resultsList.appendChild(li);
      });
    }
    var st;
    if (q) {
      q.addEventListener('input', function () { clearTimeout(st); st = setTimeout(function () { search(q.value); }, 180); }, sig);
      q.closest('form').addEventListener('submit', function (e) { e.preventDefault(); search(q.value); }, sig);
    }

    root.querySelectorAll('[data-tt-pv]').forEach(initPostventa);
  }

  // ───────────────────── Formulario postventa ─────────────────────
  function rutClean(v) { return String(v || '').replace(/[^0-9kK]/g, '').toUpperCase(); }
  function rutValid(v) {
    var r = rutClean(v);
    if (r.length < 8 || r.length > 9) return false;
    var body = r.slice(0, -1), dv = r.slice(-1), sum = 0, mul = 2;
    for (var i = body.length - 1; i >= 0; i--) { sum += +body[i] * mul; mul = mul === 7 ? 2 : mul + 1; }
    var res = 11 - (sum % 11);
    var exp = res === 11 ? '0' : res === 10 ? 'K' : String(res);
    return exp === dv;
  }
  function rutFormat(v) {
    var r = rutClean(v);
    if (r.length < 2) return r;
    var body = r.slice(0, -1).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return body + '-' + r.slice(-1);
  }
  function phoneClean(v) {
    var d = String(v || '').replace(/\D/g, '');
    if (d.indexOf('56') === 0 && d.length === 11) d = d.slice(2);
    return d;
  }
  function phoneFormat(d) { return d.length === 9 ? '+56 ' + d[0] + ' ' + d.slice(1, 5) + ' ' + d.slice(5) : d; }
  function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function initPostventa(form) {
    if (form.dataset.ready) return;
    form.dataset.ready = '1';
    var modal = form.parentNode.querySelector('[data-tt-pv-modal]');
    var preview = modal.querySelector('[data-tt-pv-preview]');
    var wa = modal.querySelector('[data-tt-pv-wa]');
    var number = form.getAttribute('data-wa') || '';
    var lastFocus = null;
    document.body.appendChild(modal);   // el modal fuera del contenido (sin recortes ni z-index raros)

    function input(name) { return form.querySelector('[data-tt-pv-input="' + name + '"]'); }
    function err(name, msg) {
      var e = form.querySelector('[data-tt-pv-err="' + name + '"]');
      if (e) e.textContent = msg || '';
      var i = input(name);
      if (i) i.classList.toggle('is-invalid', !!msg);
    }

    // Interruptores: activan/desactivan su lista de problemas
    form.querySelectorAll('[data-tt-pv-toggle]').forEach(function (t) {
      var sel = form.querySelector('[data-tt-pv-select="' + t.getAttribute('data-tt-pv-toggle') + '"]');
      function sync() { sel.disabled = !t.checked; sel.closest('.tt-pv__cat').classList.toggle('is-on', t.checked); if (!t.checked) sel.value = ''; }
      t.addEventListener('change', function () { sync(); err('problemas', ''); });
      sel.addEventListener('change', function () { if (sel.value && !t.checked) { t.checked = true; sync(); } err('problemas', ''); });
      sync();
    });

    input('rut').addEventListener('blur', function () { if (this.value) this.value = rutFormat(this.value); });
    ['nombre', 'rut', 'correo', 'telefono'].forEach(function (n) { input(n).addEventListener('input', function () { err(n, ''); }); });

    function validate() {
      var ok = true, v = {};
      v.nombre = input('nombre').value.trim();
      v.rut = input('rut').value.trim();
      v.correo = input('correo').value.trim();
      v.telefono = phoneClean(input('telefono').value);
      if (v.nombre.length < 3) { err('nombre', 'Escribe tu nombre completo'); ok = false; }
      if (!rutValid(v.rut)) { err('rut', 'RUT no válido (ej. 12.345.678-9)'); ok = false; } else v.rut = rutFormat(v.rut);
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v.correo)) { err('correo', 'Correo no válido'); ok = false; }
      if (v.telefono.length !== 9) { err('telefono', 'Teléfono de 9 dígitos (ej. 9 8765 4321)'); ok = false; }
      v.problemas = [];
      form.querySelectorAll('[data-tt-pv-toggle]').forEach(function (t) {
        if (!t.checked) return;
        var key = t.getAttribute('data-tt-pv-toggle');
        var sel = form.querySelector('[data-tt-pv-select="' + key + '"]');
        var cat = t.closest('.tt-pv__cat').querySelector('.tt-pv__cat-name').firstChild.textContent.trim();
        if (sel.value) v.problemas.push({ cat: cat, p: sel.value });
      });
      v.comentario = input('comentario').value.trim();
      if (!v.problemas.length && !v.comentario) { err('problemas', 'Elige al menos un problema o escribe un comentario'); ok = false; }
      return ok ? v : null;
    }

    function message(v) {
      var h = new Date().getHours();
      var saludo = h < 12 ? 'Buenos días.' : h < 20 ? 'Buenas tardes.' : 'Buenas noches.';
      var lines = [saludo, '', 'Soy ' + v.nombre, 'mi rut es: ' + v.rut, 'mi correo es: ' + v.correo, 'mi teléfono es: ' + phoneFormat(v.telefono), ''];
      if (v.problemas.length === 1) lines.push('Necesito ayuda con ' + v.problemas[0].cat + ': ' + v.problemas[0].p.charAt(0).toLowerCase() + v.problemas[0].p.slice(1) + '.', '');
      else if (v.problemas.length > 1) {
        lines.push('Necesito ayuda con:');
        v.problemas.forEach(function (x) { lines.push('• ' + x.cat + ': ' + x.p); });
        lines.push('');
      }
      if (v.comentario) lines.push(v.comentario, '');
      lines.push('Quedo atento a su respuesta. Gracias.');
      return lines.join('\n');
    }

    function render(v, text) {
      // vista previa: mismos textos, con los datos destacados
      var html = esc(text)
        .replace(esc(v.rut), '<b>' + esc(v.rut) + '</b>')
        .replace(esc(v.correo), '<b>' + esc(v.correo) + '</b>')
        .replace(esc(phoneFormat(v.telefono)), '<b>' + esc(phoneFormat(v.telefono)) + '</b>');
      preview.innerHTML = html.replace(/\n/g, '<br>');
    }

    function open() {
      lastFocus = document.activeElement;
      modal.hidden = false;
      document.documentElement.classList.add('tt-pv-lock');
      requestAnimationFrame(function () { modal.classList.add('is-open'); wa.focus(); });
    }
    function close() {
      modal.classList.remove('is-open');
      document.documentElement.classList.remove('tt-pv-lock');
      setTimeout(function () { modal.hidden = true; }, 200);
      if (lastFocus) lastFocus.focus();
    }
    modal.querySelectorAll('[data-tt-pv-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) close(); });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var v = validate();
      if (!v) {
        var bad = form.querySelector('.is-invalid') || form.querySelector('[data-tt-pv-err="problemas"]');
        if (bad && bad.focus) bad.focus();
        return;
      }
      var text = message(v);
      render(v, text);
      wa.href = 'https://wa.me/' + number + '?text=' + encodeURIComponent(text);
      open();
    });
  }

  // ───────────── Contenido desde la API de Shopysale (con caché en el navegador) ─────────────
  // El servidor ya dibuja lo publicado (metaobjeto) o los bloques del editor: eso lee Google.
  // Aquí: si hay una versión publicada distinta (más nueva), se dibuja esa. La última versión
  // queda en localStorage: al recargar se muestra al instante y se revisa la API cada 5 min.
  var HELP_CACHE = 'tt_help_v1', HELP_TTL = 5 * 60 * 1000;
  function hesc(t) { return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function readCache() { try { return JSON.parse(localStorage.getItem(HELP_CACHE) || 'null'); } catch (e) { return null; } }
  function writeCache(d) { try { localStorage.setItem(HELP_CACHE, JSON.stringify({ t: Date.now(), d: d })); } catch (e) {} }

  function renderData(root, d) {
    if (!d || !d.groups || !d.groups.length) return;
    var groupsBox = root.querySelector('[data-tt-help-groups]');
    var content = root.querySelector('.tt-help__content');
    var keep = content.querySelector('#mi-ticket');       // "Mi solicitud" se conserva (con su estado)
    var results = content.querySelector('[data-tt-help-results]');
    var first = '';
    d.groups.forEach(function (g) { (g.items || []).forEach(function (it) { if (!first && !it.link) first = it.handle; }); });
    var tpl = document.querySelector('template[data-tt-sac-template]');

    var nav = '', arts = '', marked = false;
    d.groups.forEach(function (g) {
      nav += '<div class="tt-help__group is-open" data-tt-help-group><button type="button" class="tt-help__group-btn" data-tt-help-groupbtn aria-expanded="true"><span>' + hesc(g.label) + '</span><i class="tt-help__pm" aria-hidden="true"></i></button><ul class="tt-help__items">';
      (g.items || []).forEach(function (it) {
        var act = !marked && it.handle === first; if (act) marked = true;
        nav += '<li><a class="tt-help__item' + (act ? ' is-active' : '') + '" href="#' + hesc(it.handle) + '" data-tt-help-link="' + hesc(it.handle) + '" data-group="' + hesc(g.label) + '">' + hesc(it.title) + '</a></li>';
        if (it.link) return;
        var extra = '';
        if (it.kind === 'faq' && it.faqs && it.faqs.length) {
          extra = '<div class="tt-help__faq">' + it.faqs.map(function (f) {
            return '<details class="tt-help__faq-item"><summary>' + hesc(f.q) + '<i class="tt-help__pm" aria-hidden="true"></i></summary><div class="tt-help__faq-a">' + (f.a || '') + '</div></details>';
          }).join('') + '</div>';
        } else if (it.kind === 'ticket_form' && tpl) {
          extra = tpl.innerHTML;
        }
        // it.html ya viene limpio desde Shopysale (lista blanca de etiquetas)
        arts += '<article class="tt-help__article' + (it.handle === first ? ' is-active' : '') + '" id="' + hesc(it.handle) + '" data-tt-help-article="' + hesc(it.handle) + '" data-group="' + hesc(g.label) + '" data-title="' + hesc(it.title) + '">' +
          '<div class="tt-help__crumb"><span class="tt-help__crumb-group">' + hesc(g.label) + '</span><span class="tt-help__crumb-sep" aria-hidden="true"></span><h2 class="tt-help__crumb-title">' + hesc(it.title) + '</h2></div>' +
          '<div class="tt-help__body rte">' + (it.html || '') + extra + '</div></article>';
      });
      nav += '</ul></div>';
    });
    groupsBox.innerHTML = nav;
    if (keep) keep.parentNode.removeChild(keep);
    content.innerHTML = '';
    if (results) content.appendChild(results);
    content.insertAdjacentHTML('beforeend', arts);
    if (keep) content.appendChild(keep);
    root.querySelectorAll('.tt-help__nav-title').forEach(function (t) { if (d.title) t.textContent = d.title; });
    var q = root.querySelector('[data-tt-help-q]'); if (q && d.searchPlaceholder) q.placeholder = d.searchPlaceholder;
    root.setAttribute('data-published', d.publishedAt || '');
    updateLd(d);
    delete root.dataset.ready;
    initHelp(root);
    if (window.ttSac) window.ttSac.init();
  }

  // FAQPage del JSON-LD con las preguntas publicadas (Google también lee el JSON-LD agregado por JS)
  function updateLd(d) {
    var faqs = [];
    d.groups.forEach(function (g) { (g.items || []).forEach(function (it) { if (it.kind === 'faq') (it.faqs || []).forEach(function (f) { faqs.push(f); }); }); });
    var old = document.querySelector('script[data-tt-help-ld-faq]');
    if (old) old.remove();
    if (!faqs.length) return;
    var s = document.createElement('script');
    s.type = 'application/ld+json'; s.setAttribute('data-tt-help-ld-faq', '');
    s.textContent = JSON.stringify({ '@context': 'https://schema.org', '@type': 'FAQPage', inLanguage: 'es-CL',
      mainEntity: faqs.map(function (f) { return { '@type': 'Question', name: f.q, acceptedAnswer: { '@type': 'Answer', text: f.aText || '' } }; }) });
    document.head.appendChild(s);
  }

  function syncFromApi(root) {
    var key = root.getAttribute('data-sac-key'), api = String(root.getAttribute('data-sac-api') || '').replace(/\/+$/, '');
    if (!key || !api) return;
    var server = root.getAttribute('data-published') || '';
    function newer(d) { return d && d.publishedAt && d.publishedAt !== server && (!server || d.publishedAt > server); }
    var c = readCache();
    if (c && c.d && newer(c.d)) { renderData(root, c.d); server = c.d.publishedAt; }   // al instante desde la caché
    if (c && Date.now() - c.t < HELP_TTL) return;                                        // caché fresca: no se consulta
    fetch(api + '/public/help-center', { headers: { 'X-Ticket-Key': key } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        if (!j || j.ok === false || !j.data) return;
        writeCache(j.data);
        if (newer(j.data)) renderData(root, j.data);
      })
      .catch(function () {});   // sin API: se queda lo del servidor / la caché
  }

  function run() { document.querySelectorAll('[data-tt-help]').forEach(function (r) { initHelp(r); syncFromApi(r); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();
